import { useEffect } from "react";

const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
    'touchstart'
];
const INTERVAL_TIME = 1000 * 60 * 60 * 4;

export const AutoLogout = () => {
    let timer;

    // this function sets the timer that logs out the user after 4 hours
    const handleLogoutTimer = () => {
        timer = setTimeout(() => {
            // clears any pending timer.
            resetTimer();
            // Listener clean up. Removes the existing event listener from the window
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            // logs out user
            logoutAction();
        }, INTERVAL_TIME);
    };

    // this resets the timer if it exists.
    const resetTimer = () => {
        if (timer) clearTimeout(timer);
    };

    // when component mounts, it adds an event listeners to the window
    // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 4 hours of inactivity resets.
    // However, if none of the event is triggered within 4 hours, that application is made inactive, the application automatically logs out.
    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleLogoutTimer();
            });
        });
    }, []);

    // logs out user by clearing out auth token in localStorage and redirecting url to /login page.
    const logoutAction = () => {
        localStorage.clear();
        window.location.pathname = "/login";
    };
};